// GENERATED by scripts/build-icons.mjs from icons/cloud-download.svg — do not edit.
// Lucide (ISC); Feather-derived icons additionally MIT. See LICENSE-lucide.
import { createIcon } from '../createIcon'

export const DownloadCloud = createIcon('cloud-download', [
  ['path', { d: "M12 13v8l-4-4" }],
  ['path', { d: "m12 21 4-4" }],
  ['path', { d: "M4.393 15.269A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.436 8.284" }],
])
